<div class="mb-8 flex items-center justify-between">
  <h1 class="flex h-11 items-center text-2xl font-bold text-aux-gray-darkest">Scenario Manager</h1>
  <div class="flex space-x-2">
    <ng-container [ngTemplateOutlet]="rightSideContainer | async" />
  </div>
</div>

<router-outlet />
